import { render, staticRenderFns } from "./manage-crossover.component.vue?vue&type=template&id=294a0dfe&"
import script from "./manage-crossover.component.vue?vue&type=script&lang=ts&"
export * from "./manage-crossover.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports